(() => {
  if (window.__allinFlexQuantityBound) return;
  window.__allinFlexQuantityBound = true;

  const selector = '[data-allin-flex-quantity="true"]';
  let priceSyncQueued = false;

  function formatMoney(cents, currency) {
    const value = Number(cents || 0) / 100;
    if ((currency || 'RON') === 'RON') {
      return new Intl.NumberFormat('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value) + ' lei';
    }
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: currency || 'RON',
    }).format(value);
  }

  function getActiveRoot() {
    return document.querySelector(selector);
  }

  function updatePrice(root) {
    if (!root) root = getActiveRoot();
    const input = root?.querySelector('input[name="quantity"]');
    if (!input) return;

    const quantity = Math.max(1, parseInt(input.value, 10) || 1);

    document.querySelectorAll('[data-allin-flex-price="true"]').forEach((container) => {
      const unitPrice = Number(container.dataset.allinUnitPrice || 0);
      const unitCompare = Number(container.dataset.allinUnitCompare || 0);
      const currency = container.dataset.allinCurrency || 'RON';
      if (!unitPrice) return;

      const total = formatMoney(unitPrice * quantity, currency);
      container
        .querySelectorAll('.price__regular .price, .price__sale .price-item--sale.price')
        .forEach((el) => {
          if (el.textContent.trim() !== total) el.textContent = total;
        });

      if (unitCompare > unitPrice) {
        const compare = formatMoney(unitCompare * quantity, currency);
        container.querySelectorAll('.compare-at-price').forEach((el) => {
          if (el.textContent.trim() !== compare) el.textContent = compare;
        });
      }
    });
  }

  function queuePriceSync() {
    if (priceSyncQueued) return;
    priceSyncQueued = true;
    requestAnimationFrame(() => {
      priceSyncQueued = false;
      updatePrice(getActiveRoot());
    });
  }

  function setQuantity(root, next) {
    const input = root.querySelector('input[name="quantity"]');
    if (!input) return;

    const min = Math.max(1, parseInt(input.min, 10) || 1);
    const max = input.max ? parseInt(input.max, 10) : null;
    let value = Math.max(min, parseInt(next, 10) || min);
    if (Number.isFinite(max)) value = Math.min(value, max);

    input.value = String(value);

    const minus = root.querySelector('[data-allin-qty="minus"]');
    const plus = root.querySelector('[data-allin-qty="plus"]');
    if (minus) minus.disabled = value <= min;
    if (plus) plus.disabled = Number.isFinite(max) && value >= max;

    updatePrice(root);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-allin-qty]');
    if (!button) return;
    const root = button.closest(selector);
    if (!root) return;

    event.preventDefault();
    const input = root.querySelector('input[name="quantity"]');
    if (!input) return;

    const current = Math.max(1, parseInt(input.value, 10) || 1);
    setQuantity(root, button.dataset.allinQty === 'minus' ? current - 1 : current + 1);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.(`${selector} input[name="quantity"]`);
    if (!input) return;
    const root = input.closest(selector);
    setQuantity(root, input.value);
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.(`${selector} input[name="quantity"]`);
    if (!input) return;
    updatePrice(input.closest(selector));
  });

  function init(root = document) {
    root.querySelectorAll?.(selector).forEach((node) => {
      const input = node.querySelector('input[name="quantity"]');
      if (!input) return;
      setQuantity(node, input.value);
    });
    queuePriceSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Horizon can re-render the product price after variant changes or add-to-cart.
  // Re-apply the total price using the current quantity whenever relevant DOM changes occur.
  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => {
      const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
      if (!target) return false;
      return (
        target.closest?.('[data-allin-flex-price="true"]') ||
        target.querySelector?.('[data-allin-flex-price="true"]') ||
        target.closest?.(selector) ||
        target.querySelector?.(selector)
      );
    });
    if (relevant) queuePriceSync();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
